import axios from 'axios'
import { storeToRefs } from 'pinia'
import useAuthStore from '@/store/auth'

const axiosDocumentIns = axios.create({
  baseURL: process.env.VUE_APP_DOCUMENT,
  // baseURL: 'https://localhost:7000/api/',
})

axiosDocumentIns.interceptors.request.use(
  config => {
    const { accessToken } = storeToRefs(useAuthStore())

    return { ...config, headers: { Authorization: `Bearer ${accessToken.value}` } }
  },
  error => Promise.reject(error),
)

export default axiosDocumentIns
